/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

const APPLICATION_STATUS_SUMMARY = 100;
const APPLICATION_STATUS_POWER_OF_ATTORNEY = 120;

const APPLICATION_STATUS_DONE = 200;

export { APPLICATION_STATUS_SUMMARY, APPLICATION_STATUS_POWER_OF_ATTORNEY, APPLICATION_STATUS_DONE };
